<template>
    <div
        class="toast"
        :class="{
            'toast--error': toast.type === 'error',
            'toast--success': toast.type === 'success',
            'toast--big': toast.theme === 'big'
        }"
    >
        <header class="toast__head">
            <span class="toast__title">
                {{ toast.type === 'error' ? 'Error: ' : '' }}{{ toast.title }}
            </span>
            <button type="button" class="toast__close" @click="removeToast(toast.id)">×</button>
        </header>
        <div class="toast__text" v-html="toast.text"></div>
        <div v-if="toast.theme === 'big'" class="toast__bottom">
            <button class="button button--blank" type="button" @click="removeToast(toast.id)">
                I Understand
            </button>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: 'Toast',
    props: {
        toast: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            timeout: null
        };
    },
    created() {
        this.timeout = setTimeout(() => {
            this.removeToast(this.toast.id);
        }, 5000);
    },
    beforeUnmount() {
        clearTimeout(this.timeout);
    },
    methods: {
        ...mapActions(['removeToast'])
    }
};
</script>

<style lang="scss" src="./Toast.scss"></style>
